module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Typ",
      "error": _vm.errors.widget_type
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Wybierz typ"
    },
    model: {
      value: (_vm.form.widget_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "widget_type", $$v)
      },
      expression: "form.widget_type"
    }
  }, _vm._l((_vm.types), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.form.widget_type === 'ticket') ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Bilet",
      "error": _vm.errors.ticket
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Wybierz bilet"
    },
    model: {
      value: (_vm.form.ticket),
      callback: function($$v) {
        _vm.$set(_vm.form, "ticket", $$v)
      },
      expression: "form.ticket"
    }
  }, _vm._l((_vm.tickets), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name_pl,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Sold out",
      "error": _vm.errors.single_ticket_sold_out
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.form.single_ticket_sold_out),
      callback: function($$v) {
        _vm.$set(_vm.form, "single_ticket_sold_out", $$v)
      },
      expression: "form.single_ticket_sold_out"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.widget_type === 'period') ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Okres",
      "error": _vm.errors.period
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Wybierz okres"
    },
    model: {
      value: (_vm.form.period),
      callback: function($$v) {
        _vm.$set(_vm.form, "period", $$v)
      },
      expression: "form.period"
    }
  }, _vm._l((_vm.periods), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name_pl,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Domyślnie rozwinięty"
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.form.expanded_at_start),
      callback: function($$v) {
        _vm.$set(_vm.form, "expanded_at_start", $$v)
      },
      expression: "form.expanded_at_start"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Kolor tła",
      "error": _vm.errors['bg_color']
    }
  }, [_c('el-color-picker', {
    model: {
      value: (_vm.form.bg_color),
      callback: function($$v) {
        _vm.$set(_vm.form, "bg_color", $$v)
      },
      expression: "form.bg_color"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Kolor tekstu",
      "error": _vm.errors['text_color']
    }
  }, [_c('el-color-picker', {
    model: {
      value: (_vm.form.text_color),
      callback: function($$v) {
        _vm.$set(_vm.form, "text_color", $$v)
      },
      expression: "form.text_color"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Program"
    }
  }, [_c('link-component', {
    attrs: {
      "errors": _vm.errors['program']
    },
    model: {
      value: (_vm.form.program),
      callback: function($$v) {
        _vm.$set(_vm.form, "program", $$v)
      },
      expression: "form.program"
    }
  })], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c0f2e81"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/forms/TicketsWidget.vue
// module id = 775
// module chunks = 0